import React, { PureComponent } from 'react';

import withStyles from './withStyles';

class Text extends PureComponent {
  render() {
    const { display, tag, className, style, children } = this.props;

    const Tag = display || tag;

    return (
      <Tag className={className} style={style}>
        {children}
      </Tag>
    );
  }
}

Text.defaultProps = {
  tag: 'p',
};

export default withStyles(Text);
